<template>
    <div class="first-step__card card clearfix">
        <loading :active.sync="isLoading" color="#4CAF50" :width=100 :height=100 :opacity=.7></loading>
        <div class="card__route">Точек: {{route.numPoints}} (№ {{route.routeId}})</div>
        <div class="card__destination">Квадрат {{route.square}} на {{route.datePlanned}}</div>
        <div class="card__info">Сектор {{route.sector}}</div>
        <a v-if="route.started" class="card__start" href="#" @click.prevent="openRoute">Открыть</a>
        <a v-else class="card__start" href="#" @click.prevent="startRoute">Стартуем!</a>
    </div>
</template>

<script>
import $backend from '../backend'
import Loading from 'vue-loading-overlay'

export default {
  name: 'Route',
  props: {
    route: Object
  },
  data () {
    return {
      isLoading: false
    }
  },
  components: {
    Loading
  },
  methods: {
    startRoute () {
      this.isLoading = true
      $backend.postData('route/start', { 'routeId': this.route.routeId })
        .then(responseData => {
          this.route.started = true
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    openRoute () {
      this.$router.push({ name: 'points', params: { routeId: this.route.routeId } })
    }
  }
}
</script>
